/* Force Vendor Spotlight to begin on a genuinely random vendor on every page load. */
(function(){
  function randomize(root){
    if(!root) return;
    var track=root.querySelector('[data-track]');
    if(!track) return;
    var slides=Array.prototype.slice.call(track.querySelectorAll('[data-vendor-slide]'));
    if(slides.length<2) return;
    /* Fisher-Yates using crypto when available, Math.random fallback. */
    function rand(max){
      if(window.crypto&&window.crypto.getRandomValues){var a=new Uint32Array(1);window.crypto.getRandomValues(a);return a[0]%max;}
      return Math.floor(Math.random()*max);
    }
    for(var i=slides.length-1;i>0;i--){var j=rand(i+1),t=slides[i];slides[i]=slides[j];slides[j]=t;}
    slides.forEach(function(s){track.appendChild(s);});
    /* Existing spotlight code may already have picked an index. Put a newly randomized vendor at position zero. */
    track.style.transform='translate3d(0,0,0)';
    var dots=root.querySelector('[data-dots]');
    if(dots){var ds=dots.querySelectorAll('.svs-dot');ds.forEach(function(d,k){d.classList.toggle('is-active',k===0);});}
  }
  function boot(){document.querySelectorAll('[data-svs]').forEach(randomize);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){setTimeout(boot,20);});else setTimeout(boot,20);
  document.addEventListener('shopify:section:load',function(e){setTimeout(function(){var r=e.target.matches&&e.target.matches('[data-svs]')?e.target:e.target.querySelector('[data-svs]');randomize(r);},30);});
})();
